import { useCallback, useEffect, useRef } from 'react';
export function useMutationObserver(element, callback, options = {}) {
    const observer = useRef(null);
    const stop = useCallback(() => {
        if (!observer.current)
            return;
        observer.current.disconnect();
        observer.current = null;
    }, []);
    useEffect(() => {
        var _a;
        if (!element)
            return;
        observer.current = new MutationObserver(callback);
        (_a = observer.current) === null || _a === void 0 ? void 0 : _a.observe(element, options);
        return stop;
    }, [callback, stop, options, element]);
    useEffect(() => stop, []);
}
